import GhostContentAPI from '@tryghost/content-api';

const api = new GhostContentAPI({
  url: 'https://hub.streamon.dev',
  key: '13d7726cd2f3cbac351f1cfa68',
  version: 'v3',
});

export default api;
